module.exports = __webpack_public_path__ + "static/media/arrow-left.6d9036c4.svg";